var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"订单日志","visible":_vm.visible,"close-on-click-modal":false,"width":"1100px"},on:{"close":_vm.close}},[_c('grid-table',{ref:"gridTable",attrs:{"tableConfig":_vm.tableConfig,"showCheckboxColumn":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }